import React, { useState, useEffect } from 'react';
import { useTexture } from '../../../../Shared/TextureContext';

const TextureFilter = ({ id, textureUrl, fill = "", patternType = "signet" }) => {
  const [resolvedUrl, setResolvedUrl] = useState(null);
  const { getTextureFromCache } = useTexture();

  useEffect(() => {
    if (!textureUrl) {
      setResolvedUrl(null);
      return;
    }
    
    // Load texture from cache or fetch it
    const loadTexture = async () => {
      try {
        // Use 'signet' as the texture type for Signet Studio
        const cachedTexture = await getTextureFromCache(textureUrl, patternType);
        if (cachedTexture) {
          setResolvedUrl(cachedTexture);
        }
      } catch (error) {
        console.error('Error loading texture:', error);
      }
    };

    // Start loading
    loadTexture();
  }, [textureUrl, getTextureFromCache, patternType]);

  // If there's no texture URL or resolved URL, just apply the fill color if provided
  if (!textureUrl || !resolvedUrl) {
    return fill ? (
      <filter id={id} x="-50%" y="-50%" width="200%" height="200%">
        <feFlood floodColor={fill} floodOpacity={0.04} result="flood" />
        <feComposite in="flood" in2="SourceGraphic" operator="in" />
      </filter>
    ) : null;
  }

  return (
    <filter id={id} x="-50%" y="-50%" width="200%" height="200%">
      {/* Include the texture operations */}
      <feImage
        result="texture"
        href={resolvedUrl}
        // x="0"
        // y="0"
        // width="100%"
        // height="100%"
        preserveAspectRatio="none"
      />
      <feTile in="texture" result="tiledTexture" />
      <feComposite in="tiledTexture" in2="SourceGraphic" operator="in" />

      {/* Always include the fill if provided */}
      {fill && (
        <>
          <feFlood floodColor={fill} floodOpacity={0.04} result="flood" />
          <feComposite in="flood" in2="SourceGraphic" operator="in" />
        </>
      )}
    </filter>
  );
};

export default TextureFilter;
